import io from 'socket.io-client'
import {base, user, debug, track} from 'lib'

const log = debug.create('socketio');
const error = debug.create('socketio:error');


class SocketIo {
  constructor(params = {}) {
    this.isConnected = false
    this.init(params)
  }

  init = ({
            url,
            roomId,
            onConnected = () => {
            },
            onDisconnected = () => {
            },
            onMessage = () => {
            },
            onError = () => {
            }
          }) => {

    if (roomId) {
      url = base.getUrl(`?room_id=${roomId}&access_token=${user.getToken()}&client_id=${track.getClientId()}`, 'ws')
      log('socket url=>', url)
    }

    if (!url) {
      log('socket url is null')
      return;
    }


    this.socket = io(url, {
      // forceNew: false,
      transports: ['websocket', 'polling']
    })

    log('socket init');

    this.socket.on('connect', () => {
      this.isConnected = true
      log('connect success')
      onConnected && onConnected();
    })

    this.socket.on('disconnect', () => {
      this.isConnected = false
      log('socket disconnect')
      onDisconnected && onDisconnected();
    })

    this.socket.on('error', (e) => {
      log('connect has error', e)
      onError && onError()
    })

    this.socket.on('message', (msg, fn) => {
      // log('[socket]', msg)
      // try {
      //     // msg = JSON.parse(msg)
      // } catch (e) {
      //     error('socket message error', e)
      //     return
      // }
      onMessage && onMessage(msg)
    })
  }

  sendMsg(msg, cb) {
    if (this.isConnected) {
      log('[send msg]', msg)
      this.socket.emit('message', JSON.stringify(msg), (res) => {
        cb && cb(res);
      })
    } else {
      // toast('socket 未连接')
      log('socket is not connected')
    }
  }

  close = () => {
    this.socket && this.socket.close()
  }

}


export default SocketIo;
